<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <div v-if="$gate.isServiceAdmin()">
            <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

            <section class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h2>{{ $route.meta.title }}</h2>
                        </div>
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item">
                                    <a href="/home">Home</a>
                                </li>
                                <li class="breadcrumb-item active">
                                    {{ $route.meta.title }}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
                <!-- /.container-fluid -->
            </section>

            <!-- Main content -->
            <section class="content">
                <br />

                <!-- main row for all icons  -->

                <div class="col-lg-12">
                    <div class="card card-danger card-outline collapsed-card">
                        <div class="card-header">
                            <div class="card-title">Data Filters</div>
                            <div class="card-tools">
                                <!-- Collapse Button -->
                                <button
                                    type="button"
                                    class="btn btn-tool"
                                    data-card-widget="collapse"
                                >
                                    <i class="fas fa-minus"></i>
                                </button>
                            </div>
                        </div>
                        <div class="card-body overflow-auto">
                            <br />
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <span
                                                class="right badge badge-secondary"
                                                >Select Year:</span
                                            >
                                            <input
                                                type="number"
                                                class="form-control"
                                                v-model="year"
                                                placeholder="Select From date"
                                                min="2021"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <span
                                                class="right badge badge-secondary"
                                                >Search by Branch:</span
                                            >
                                            <v-select
                                                v-model="branch"
                                                class="form-control"
                                                type="text"
                                                label="branch"
                                                :options="branchv"
                                                :reduce="
                                                    (branchv) =>
                                                        branchv.branch_code
                                                "
                                                name="branch"
                                                placeholder="Select Branch"
                                                :value="
                                                    (branchv) =>
                                                        branchv.branch_code
                                                "
                                            ></v-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <span
                                                class="right badge badge-secondary"
                                            ></span>
                                            <button
                                                class="btn btn-danger"
                                                style="width: 100% !important"
                                                @click="
                                                    getData('/api/annualGP')
                                                "
                                            >
                                                <i class="fa fa-search"></i>
                                                Search
                                            </button>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <span
                                                class="right badge badge-secondary"
                                            ></span>
                                            <button
                                                class="btn btn-danger"
                                                style="width: 100% !important"
                                                @click="reset"
                                            >
                                                <i class="fa fa-times"></i>
                                                Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <br />
                <br />

                <div class="col-md-12">
                    <div class="row" align="center">
                        <div class="col-lg-4 col-6">
                            <!-- small box -->
                            <div class="small-box bg-danger">
                                <div class="inner">
                                    <h3>{{ total }}</h3>
                                    <p>Total</p>
                                </div>
                                <div class="icon">
                                    <i class="ion ion-person-add"></i>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-6">
                            <!-- small box -->
                            <div class="small-box bg-danger">
                                <div class="inner">
                                    <h3>{{ spare }}</h3>
                                    <p>Spare</p>
                                </div>
                                <div class="icon">
                                    <i class="ion ion-pie-graph"></i>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-6">
                            <!-- small box -->
                            <div class="small-box bg-danger">
                                <div class="inner">
                                    <h3>{{ profit }}</h3>
                                    <p>Profit</p>
                                </div>
                                <div class="icon">
                                    <i class="ion ion-bag"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <br />

                <div class="col-sm-12 overflow-auto">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="card card-danger card-outline">
                                <div class="card-header">
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <h5>Report</h5>
                                        </div>
                                        <!-- <div class="col-sm-6">
                 <button class="btn btn-primary float-right" @click="exportPms"><i class="fa fa-print"></i> Export</button>
               </div> -->
                                    </div>
                                </div>
                                <div class="card-body overflow-auto">
                                    <table
                                        class="table table-striped table-bordered table-hover"
                                    >
                                        <thead>
                                            <tr>
                                                <!-- all amounts are pre-tax -->
                                                <th>Branch</th>
                                                <th>January</th>
                                                <th>February</th>
                                                <th>March</th>
                                                <th>April</th>
                                                <th>May</th>
                                                <th>June</th>
                                                <th>July</th>
                                                <!-- list all job categories -->
                                                <th>August</th>
                                                <th>September</th>
                                                <th>October</th>
                                                <th>November</th>
                                                <th>December</th>
                                                <!-- list all job categories -->
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="branch in branches">
                                                <td>
                                                    {{ branch.BRANCH_NAME }}
                                                </td>
                                                <td v-for="i in 12">
                                                    <tr>
                                                        <th>Total</th>
                                                        <th>Spare</th>
                                                        <th>Profit</th>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            {{
                                                                branch[i - 1]
                                                                    .total
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                branch[i - 1]
                                                                    .spare
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                branch[i - 1]
                                                                    .profit
                                                            }}
                                                        </td>
                                                    </tr>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- </div> -->
                </div>
                <!-- row end -->
            </section>
            <!-- /.content -->

            <!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isServiceAdmin()">
            <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        console.log("Component mounted.");
    },

    created() {
        var date = new Date();
        this.year = date.getFullYear();
        this.getBranches();
        this.getData();
    },

    data() {
        return {
            branches: [],
            branchv: [],
            year: "",
            total: "",
            spare: "",
            profit: "",
            branch: "",
        };
    },

    methods: {
        getBranches() {
            axios.post("/api/getBranches").then((response) => {
                this.branchv = response.data;
            });
        },

        getData(url = "/api/annualGP") {
            axios
                .post(url, { year: this.year, branch: this.branch })
                .then((response) => {
                    this.branches = response.data.data;
                    this.total = response.data.total;
                    this.spare = response.data.spare;
                    this.profit = response.data.profit;
                });
        },

        reset() {
            var date = new Date();
            this.year = date.getFullYear();
            this.branch = "";
            this.getData();
        },
    },
};
</script>
